var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    { ref: "form" },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", sm2: "", md1: "" } },
            [
              _c(
                "v-tooltip",
                { attrs: { disabled: !_vm.showTooltip, top: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      slot: "activator",
                      "error-messages": _vm.minutesErrors,
                      type: "number",
                      label: "Minutes",
                      required: ""
                    },
                    on: {
                      input: function($event) {
                        return _vm.v.$each[_vm.index].minutes.$touch()
                      },
                      blur: function($event) {
                        return _vm.v.$each[_vm.index].minutes.$touch()
                      }
                    },
                    slot: "activator",
                    model: {
                      value: _vm.record.minutes,
                      callback: function($$v) {
                        _vm.$set(_vm.record, "minutes", $$v)
                      },
                      expression: "record.minutes"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Enter # of minutes for procedure")])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm10: "", md7: "" } },
            [
              _c(
                "v-tooltip",
                { attrs: { disabled: !_vm.showTooltip, top: "" } },
                [
                  _c("v-combobox", {
                    attrs: {
                      slot: "activator",
                      items: _vm.medicaidArray,
                      label: "Procedure Description",
                      "item-text": "procedureName",
                      "error-messages": _vm.procedureErrors,
                      multiple: "",
                      "return-object": true
                    },
                    on: {
                      change: function($event) {
                        return _vm.formatProcedureArrayForSubmit(_vm.index)
                      },
                      blur: function($event) {
                        return _vm.v.$each[_vm.index].procedures.$touch()
                      }
                    },
                    slot: "activator",
                    scopedSlots: _vm._u([
                      {
                        key: "item",
                        fn: function(ref) {
                          var item = ref.item
                          var tile = ref.tile
                          return [
                            _c("v-checkbox", {
                              attrs: {
                                label:
                                  item.categoryName + ": " + item.procedureName
                              },
                              model: {
                                value: tile.props.value,
                                callback: function($$v) {
                                  _vm.$set(tile.props, "value", $$v)
                                },
                                expression: "tile.props.value"
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "selection",
                        fn: function(ref) {
                          var item = ref.item
                          var selected = ref.selected
                          return [
                            _c(
                              "v-chip",
                              {
                                attrs: { small: "", close: "" },
                                on: {
                                  input: function($event) {
                                    return _vm.remove(item.procedureName)
                                  }
                                }
                              },
                              [
                                item.categoryName && item.procedureName
                                  ? _c("span", [
                                      _c("strong", [
                                        _vm._v(_vm._s(item.categoryName))
                                      ]),
                                      _vm._v(
                                        ": " +
                                          _vm._s(item.procedureName) +
                                          "\n              "
                                      )
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        "\n                Other: " +
                                          _vm._s(item.procedureName) +
                                          "\n              "
                                      )
                                    ])
                              ]
                            )
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.record.procedures,
                      callback: function($$v) {
                        _vm.$set(_vm.record, "procedures", $$v)
                      },
                      expression: "record.procedures"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("Select one or more procedure description(s)")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs10: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Outcome",
                  "error-messages": _vm.outcomeErrors,
                  counter: "",
                  maxlength: "200"
                },
                on: {
                  input: function($event) {
                    return _vm.v.$each[_vm.index].outcome.$touch()
                  },
                  blur: function($event) {
                    return _vm.v.$each[_vm.index].outcome.$touch()
                  }
                },
                model: {
                  value: _vm.record.outcome,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.record,
                      "outcome",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "record.outcome"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs2: "", md1: "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "", "justify-end": "" } },
                [
                  _c(
                    "v-tooltip",
                    { attrs: { disabled: !_vm.showTooltip, top: "" } },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: { "padding-top": "20px" },
                          attrs: { slot: "activator", id: "deleteIcon" },
                          on: {
                            click: function($event) {
                              return _vm.emitRemoveRecordClicked(_vm.index)
                            }
                          },
                          slot: "activator"
                        },
                        [_vm._v("\n            mdi-delete\n          ")]
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v("Delete procedure")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tooltip",
                    { attrs: { disabled: !_vm.showTooltip, top: "" } },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: { "padding-top": "20px" },
                          attrs: { slot: "activator", id: "addIcon" },
                          on: { click: _vm.emitAddRecordClicked },
                          slot: "activator"
                        },
                        [_vm._v("\n            mdi-plus-box\n          ")]
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v("Add procedure")])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-680383d1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-680383d1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-log/form/medicaid-repeatable/medicaid-repeatable.vue
// module id = null
// module chunks = 